import StageAreaChart from './StageAreaChart';
import { type Snapshot } from './helpers';

/** Per-service Cloud Run instance counts; stack height reads as total fleet size. */
export default function InstancesChart({ history }: { history: Snapshot[] }) {
  return <StageAreaChart history={history} getValue={(stage) => stage.instances} yTitle="instances" />;
}
